import React, { useState } from 'react';
import { Typography, Box } from "@mui/joy";

import StarIcon from '@mui/icons-material/Star';
import { useThemeContext } from '../../context/ThemeContext';
import FundProfileUser from '../userprofile/fundi/FundProfileUser';


const Reviews = ({ rating, setRating }) => {

    const [hover, setHover] = useState(null);
    return (
        <Box sx={{ display: 'flex', gap: '1px' }}>
            {[...Array(5)].map((_, index) => {
                const starValue = index + 1;
                return (
                    <StarIcon
                        key={index}
                        style={{
                            cursor: 'pointer',
                            color: starValue <= (hover || rating) ? '#ffc107' : '#e4e5e9',
                        }}
                        onMouseEnter={() => setHover(starValue)}
                        onMouseLeave={() => setHover(null)}
                        onClick={() => setRating(starValue)}
                    />
                );
            })}
        </Box>
    );
};


const initialData =
{
    id: '6541654651',
    name: 'Rolex hood',
    skill: 'Plubmbing, Cleaning, Appliance Repair, Installation, Uninstallation, Repair',
    location: '123, Street Name, Landmark,UK',
    price: 120,
    rating: 4,
    reviews: 'Customer Reviews',
    job: 'Post Job',
    servicecategories: 'Plumbing',
    subcategories: 'Pipe Instalation',
    description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Cupiditate ducimus sed, laboriosam maxime, autem fugiat doloremque minima natus sapiente aspernatur qui totam eligendi, ea ipsam rerum culpa eveniet nulla velit.Lorem ipsum dolor sit amet consectetur adipisicing elit. Cupiditate ducimus sed, laboriosam maxime, autem fugiat doloremque minima natus sapiente aspernatur qui totam eligendi, ea ipsam rerum culpa eveniet nulla velit',
    role: 'customer',
    date: '50/11/2025',
    time: '10:30pm',
    imagesUrl: 'assets/images/Mask group (11).png',
    star: 4,
}

const FundProfileSection = () => {

    const { isSM, isMd, isMD, isLg } = useThemeContext()
    const [data, setData] = useState(initialData);

    const updateRating = (id, newRating) => {
        setData((prevData) =>
            prevData.map((item) => (item.id === id ? { ...item, rating: newRating } : item))
        );
    };


    return (
        <>

            <Box
                sx={{
                    width: isSM ? '100%' : isMD ? '100%' : isMd ? '1007px' : isLg ? '1207px' : '1207px',
                    padding: isSM ? '5px' : isMD ? '10px' : isMd ? '10px' : 0,
                    margin: '0 auto',
                    boxSizing: 'border-box',
                }}
            >

                <Box sx={{ display: 'flex', justifyContent: 'space-between', marginTop: '1rem' }}>
                    <Box sx={{ marginLeft: isSM ? '0.5rem' : isMD ? '2rem' : isMd ? '3rem' : isLg ? '4rem' : '4rem', }}>
                        <FundProfileUser />
                    </Box>

                    <Box
                        sx={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            justifyContent: 'space-between',
                            mb: 2,
                            p: 2,
                            width: '100%',

                        }}
                    >
                        <Box sx={{ flex: 1, p:2 }}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    justifyContent:'flex-start',
                                    justifyItems:'center',
                                    alignItems:'center',
                                    gap:3,
                                    width: '400px',
                                    maxWidth: '100%',
                                }}
                            >
                                <Box sx={{textAlign: 'left' }}>
                                    <Typography  sx={{ fontWeight:500, fontSize:'24px' }}>
                                        {data.name}
                                    </Typography>
                                </Box>
                               <Box>
                               <Reviews
                                        rating={data.rating}
                                        setRating={(newRating) => updateRating(data.id, newRating)}
                                    />
                               </Box>
                            </Box>
                            <Typography
                                sx={{
                                    width: '400px',
                                    maxWidth: '100%',
                                    color: '#666666'
                                }}
                            >
                                {data.skill}
                            </Typography>
                        </Box>

                        <Box
                            sx={{
                                padding: '10px',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'start',
                                textAlign: 'center',
                                boxShadow: 'none',
                                height: '150px',
                            }}
                        >
                            <Typography
                                sx={{
                                    fontSize: '22px',
                                    fontWeight: '500',

                                }}
                            >
                                Location
                            </Typography>
                            <Typography
                                sx={{
                                    fontSize: '16px',
                                    fontWeight: '400',
                                    mt: 2,
                                }}
                            >
                                {data.location}
                            </Typography>

                        </Box>
                    </Box>
                </Box>
            </Box>


        </>
    );
}

export default FundProfileSection;

